// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rG-z","hovered":"sG-z","hoverImage":"tG-z","mainImage":"uG-z","imageNoBackground":"vG-z","fullSizeImage":"wG-z"};